import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableProps } from 'rsuite/lib/Table';
import { RootState } from '../../@types/RootState';

export type GetStoreFamilyClusterModalPaginationStateSortState<K extends TableProps['sortColumn'] = string> = {
  type: K;
  orderBy: TableProps['sortType'];
};

const initialState: GetStoreFamilyClusterModalPaginationStateSortState = {
  type: 'productIds',
  orderBy: 'asc',
};

const slice = createSlice({
  name: 'getStoreFamilyClusterModal/sort',
  initialState,
  reducers: {
    SET_GET_STORE_FAMILY_CLUSTER_MODAL_SORT: (_state, { payload }: PayloadAction<GetStoreFamilyClusterModalPaginationStateSortState>) => payload,
    RESET_GET_STORE_FAMILY_CLUSTER_MODAL_SORT: () => initialState,
  },
});

export const { SET_GET_STORE_FAMILY_CLUSTER_MODAL_SORT, RESET_GET_STORE_FAMILY_CLUSTER_MODAL_SORT } = slice.actions;

export const selectorGetStoreFamilyClusterModalSort = (state: RootState) => {
  return state.getStoreFamilyClusterModalReducer.sort;
};

export default slice.reducer;
